import { AxiosPromise } from 'axios';
import { UpdateContactRequest } from '../../types/Contact';
import {
    ContactField,
    CreateContactFieldRequest,
    DeleteContactFieldRequest,
    UpdateContactFieldRequest,
} from '../../types/ContactField';
import { libApiInstance } from '../axios';

export function requestCreateContactField(
    contactId: number,
    data: CreateContactFieldRequest,
    signal?: AbortSignal,
): AxiosPromise<ContactField> {
    return libApiInstance.post(`/contacts/${contactId}/fields`, data, {
        signal,
    });
}

export function requestUpdateContactField(
    contactId: number,
    data: UpdateContactFieldRequest,
    signal?: AbortSignal,
): AxiosPromise<boolean> {
    return libApiInstance.put(`/contacts/${contactId}/fields`, data, {
        signal,
    });
}

export function requestUpdateContact(
    contactId: number,
    data: UpdateContactRequest,
    signal?: AbortSignal,
): AxiosPromise<unknown> {
    return libApiInstance.put(`/contacts/${contactId}/fields`, data, {
        signal,
    });
}

export function requestDeleteContactField(
    contactId: number,
    data: DeleteContactFieldRequest,
    signal?: AbortSignal,
): AxiosPromise<boolean> {
    return libApiInstance.delete(`/contacts/${contactId}/fields`, {
        signal,
        data,
        headers: {
            'Content-Type': 'application/json',
        },
    });
}

export function requestBatchUpdateContactFields(
    contactId: number,
    data: UpdateContactRequest[],
    signal?: AbortSignal,
): AxiosPromise<boolean> {
    return libApiInstance.put(`/contacts/${contactId}/fields/batchUpdate`, data, { signal });
}
